import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const BIGFOOTERBODYLOGOBLOCK_LEGACY_FIELD_ORDER = [
  "logo"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  bigFooterBodyLogoBlockDescriptor: _generatedBigFooterBodyLogoBlockDescriptor,
  bigFooterBodyLogoBlockBlocDefinition,
  bigFooterBodyLogoBlockDashboardLayout,
  bigFooterBodyLogoBlockConfig,
  bigFooterBodyLogoBlockResolveConfig,
  bigFooterBodyLogoBlockProperties,
} = doodBlockConfig(
  {
    name: "Big footer - Body - Logo",
    componentType: 'BigFooterBodyLogoBlockComponent',
    category: 'footer',
    description: "Big footer - Body - Logo.",
    keywords: [],
    allowedIn: [
      { bloc: "BigFooterBlockComponent", slot: "left_body" },
      { bloc: "BigFooterColumnBlockComponent", slot: "items" },
    ],
    sharedFields: {}
  },

  () => ({
    logo: propertyValue({
      type: 'image',
      value: '',
      options: {
        label: "pages.blocks.big-footer-body-logo.logo.label",
        help: "pages.blocks.big-footer-body-logo.logo.help",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.big-footer-body-logo.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.big-footer-body-logo.fieldset.logo.label",
            fields: ["logo"],
          },
        ],
      },
    ],
  })
);

export function bigFooterBodyLogoBlockDescriptor(): IBlockDescriptor;
export function bigFooterBodyLogoBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function bigFooterBodyLogoBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedBigFooterBodyLogoBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedBigFooterBodyLogoBlockDescriptor, bigFooterBodyLogoBlockProperties, fieldOrder);
}

export {
  bigFooterBodyLogoBlockBlocDefinition,
  bigFooterBodyLogoBlockDashboardLayout,
  bigFooterBodyLogoBlockProperties,
  bigFooterBodyLogoBlockConfig,
  bigFooterBodyLogoBlockResolveConfig,
};

export type BigFooterBodyLogoBlockConfig = typeof bigFooterBodyLogoBlockConfig;
